import { Injectable } from '@angular/core';
import { NewAuthTokenResponse } from '@app/core/auth/interfaces/new-access-token-response';
import { ApiService } from '@app/core/services/api.service';
import { Observable } from 'rxjs';
import { UpdateProfileReqDto } from '../interfaces/update-profile.req.dto';
import { User } from '../interfaces/user';

@Injectable({
  providedIn: 'root',
})
export class UsersService {
  constructor(private apiService: ApiService) {}

  getProfile(): Observable<User> {
    return this.apiService.get<User>('profile');
  }

  updateProfile(data: UpdateProfileReqDto): Observable<NewAuthTokenResponse> {
    return this.apiService.put<NewAuthTokenResponse>('profile', data);
  }
  // updateProfile(data: any): Observable<NewAuthTokenResponse> {
  //   return this.apiService.put<NewAuthTokenResponse>('user', data);
  // }
}
